import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const ClienteFormModal = ({
  open,
  onClose,
  nuevoCliente,
  setNuevoCliente,
  onGuardar
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-[#0E3A53]" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Nuevo Cliente
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="nombre-cliente">Nombre *</Label>
            <Input
              id="nombre-cliente"
              data-testid="input-nombre-cliente"
              value={nuevoCliente.nombre}
              onChange={(e) => setNuevoCliente({ ...nuevoCliente, nombre: e.target.value })}
              placeholder="Nombre completo"
            />
          </div>
          <div>
            <Label htmlFor="telefono-cliente">Teléfono</Label>
            <Input
              id="telefono-cliente"
              data-testid="input-telefono-cliente"
              type="tel"
              value={nuevoCliente.telefono}
              onChange={(e) => setNuevoCliente({ ...nuevoCliente, telefono: e.target.value })}
              placeholder="+56 9 1234 5678"
            />
          </div>
          <div>
            <Label htmlFor="email-cliente">Email</Label>
            <Input
              id="email-cliente"
              data-testid="input-email-cliente"
              type="email"
              value={nuevoCliente.email}
              onChange={(e) => setNuevoCliente({ ...nuevoCliente, email: e.target.value })}
              placeholder="correo@ejemplo.com"
            />
          </div>
          <div>
            <Label htmlFor="notas-cliente">Notas</Label>
            <Input
              id="notas-cliente"
              data-testid="input-notas-cliente"
              value={nuevoCliente.notas}
              onChange={(e) => setNuevoCliente({ ...nuevoCliente, notas: e.target.value })}
              placeholder="Información adicional"
            />
          </div>
        </div>
        <div className="flex gap-3 justify-end mt-4">
          <Button 
            variant="outline" 
            onClick={onClose}
            data-testid="cancel-cliente-btn"
          >
            Cancelar
          </Button>
          <Button 
            onClick={onGuardar}
            data-testid="save-cliente-btn"
            className="bg-gradient-to-r from-[#1AA1D8] to-[#0E3A53]"
            disabled={!nuevoCliente.nombre.trim()}
          >
            Crear Cliente
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClienteFormModal;
